import { BaseApi } from './base.api.js';

export class OutboxMonitorApi extends BaseApi {
    constructor(client) {
        super(client, '/outbox-events');
    }

    async getSummary() {
        const response = await this.client.get(`${this.basePath}/summary`);
        return response.data;
    }

    async list(params = {}) {
        const response = await this.client.get(this.basePath, { params });
        return response.data;
    }
}
